import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import CircularProgress from "@material-ui/core/CircularProgress";

import Swal from "sweetalert2";
import AdminLayout from "./AdminLayout";
import CustomMuiDataTable from "src/Components/CustomMuiDataTable";
import AddUpdateStatuses from "./AddUpdateStatuses";

const AdminStatuses = () => {
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({ name: "", color: "", isFinal: 0, id: -1 });
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getData = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API}/admin/statuses/get`)
      .then((response) => {
        setData(response.data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        toast.error("Error loading statuses");
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const addForm = () => {
    setFormData({ name: "", color: "", isFinal: 0, id: -1 });
    setVisible(true);
  };

  const updateForm = (meta) => {
    const id = meta.rowData[0];
    axios
      .get(`${process.env.REACT_APP_API}/admin/statuses/getById/${id}`)
      .then((response) => {
        setFormData({
          name: response.data.name,
          color: response.data.color,
          isFinal: response.data.isFinal,
          id: id,
        });
        setVisible(true);
      })
      .catch(() => {
        toast.error("Error");
      });
  };

  const deleteForm = (meta) => {
    const id = meta.rowData[0];
    Swal.fire({
      title: "Please Confirm Your Action?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      icon: "warning",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(`${process.env.REACT_APP_API}/admin/statuses/delete`, { id })
          .then(() => {
            toast.success("Deleted successfully");
            getData();
          })
          .catch(() => {
            toast.error("Error");
          });
      }
    });
  };

  const columns = [
    { name: "id", label: "ID" },
    { name: "name", label: "Name" },
    {
      name: "color",
      label: "Color",
      options: {
        customBodyRender: (value) => (
          <div style={{ backgroundColor: value, width: "60%", height: "30px", borderRadius: "5px" }} />
        ),
      },
    },
    {
      name: "isFinal",
      label: "Is Final",
      options: {
        customBodyRender: (value) => (
          <input className="form-check-input" type="checkbox" readOnly checked={value == 1} />
        ),
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, meta) => (
          <div>
            <button className="btn btn-primary mx-1" onClick={() => updateForm(meta)}>Update</button>
            <button className="btn btn-danger mx-1" onClick={() => deleteForm(meta)}>Delete</button>
          </div>
        ),
      },
    },
  ];

  const options = {
    filter: true,
    rowsPerPage: 50,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: "none",
    customToolbar: () => (
      <Tooltip title="Add">
        <IconButton onClick={addForm}>
          <AddIcon />
        </IconButton>
      </Tooltip>
    ),
    textLabels: {
      body: {
        noMatch: isLoading ? <CircularProgress /> : "There is no matching data to display",
      },
    },
  };

  return (
    <AdminLayout>
      <div className="container">
        <CustomMuiDataTable title="Statuses" data={data} columns={columns} options={options} />
        <AddUpdateStatuses
          visible={visible}
          setVisible={setVisible}
          formData={formData}
          setFormData={setFormData}
          getData={getData}
        />
      </div>
    </AdminLayout>
  );
};

export default AdminStatuses;
